import { ObservableArray, View, ViewModel } from "binder"
import { AutomatedPriceUpdatingViewModel, calculationTypeProvider, indexEnumProvider, priceRelation, singleProductPrice } from "./automatedPriceUpdating-viewModel"

export class AutomatedPriceUpdatingView extends View<AutomatedPriceUpdatingViewModel>{
    GetViewUniqueId(): string {
        return "V-5B27A582-D084-4BCA-B29E-7E8FF6F89199"
    }
    loadHtml(): string {
        let element = require('./automatedPriceUpdating.html').default;
        let style = require('./automatedPriceUpdating.less');
        return element;
    }
    constructor() {
       super();
    }

    
    public set prices(v: ObservableArray<singleProductPrice>) { this._prices = v; } public get prices(): ObservableArray<singleProductPrice> { return this._prices;} private _prices: ObservableArray<singleProductPrice>;
    public set shallShowPopup(v: boolean) { this._shallShowPopup = v; } public get shallShowPopup(): boolean { return this._shallShowPopup;} private _shallShowPopup: boolean;
    public set popup(v: ViewModel) { this._popup = v; } public get popup(): ViewModel { return this._popup;} private _popup: ViewModel;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set currentAllProductPriceSum(v: number) { this._currentAllProductPriceSum = v; } public get currentAllProductPriceSum(): number { return this._currentAllProductPriceSum;} private _currentAllProductPriceSum: number;
    public set calculatedPriceSum(v: number) { this._calculatedPriceSum = v; } public get calculatedPriceSum(): number { return this._calculatedPriceSum;} private _calculatedPriceSum: number;
    public set finalPriceSum(v: number) { this._finalPriceSum = v; } public get finalPriceSum(): number { return this._finalPriceSum;} private _finalPriceSum: number;

    public set allBalance(v: number) { this._allBalance = v; } public get allBalance(): number { return this._allBalance;} private _allBalance: number;
    public set allNoSaleLockBalance(v: number) { this._allNoSaleLockBalance = v; } public get allNoSaleLockBalance(): number { return this._allNoSaleLockBalance;} private _allNoSaleLockBalance: number;
    public set allHunt(v: number) { this._allHunt = v; } public get allHunt(): number { return this._allHunt;} private _allHunt: number;
    public set allInWay(v: number) { this._allInWay = v; } public get allInWay(): number { return this._allInWay;} private _allInWay: number;
    public set allSale(v: number) { this._allSale = v; } public get allSale(): number { return this._allSale;} private _allSale: number;
    public set allCancel(v: number) { this._allCancel = v; } public get allCancel(): number { return this._allCancel;} private _allCancel: number;
    public set allReturn(v: number) { this._allReturn = v; } public get allReturn(): number { return this._allReturn;} private _allReturn: number;
    public set allMarkaziSale(v: number) { this._allMarkaziSale = v; } public get allMarkaziSale(): number { return this._allMarkaziSale;} private _allMarkaziSale: number;
    public set allMellatSale(v: number) { this._allMellatSale = v; } public get allMellatSale(): number { return this._allMellatSale;} private _allMellatSale: number;
    
    public set huntEnumProvider(v: indexEnumProvider) { this._huntEnumProvider = v; } public get huntEnumProvider(): indexEnumProvider { return this._huntEnumProvider;} private _huntEnumProvider: indexEnumProvider;
    public set saleEnumProvider(v: indexEnumProvider) { this._saleEnumProvider = v; } public get saleEnumProvider(): indexEnumProvider { return this._saleEnumProvider;} private _saleEnumProvider: indexEnumProvider;
    public set purchaseEnumProvider(v: indexEnumProvider) { this._purchaseEnumProvider = v; } public get purchaseEnumProvider(): indexEnumProvider { return this._purchaseEnumProvider;} private _purchaseEnumProvider: indexEnumProvider;
    public set calculationTypeEnumProvider(v: calculationTypeProvider) { this._calculationTypeEnumProvider = v; } public get calculationTypeEnumProvider(): calculationTypeProvider { return this._calculationTypeEnumProvider;} private _calculationTypeEnumProvider: calculationTypeProvider;
    
    public set isAdmin(v: boolean) { this._isAdmin = v; } public get isAdmin(): boolean { return this._isAdmin;} private _isAdmin: boolean;
    public set reportDay(v: moment.Moment) { this._reportDay = v; } public get reportDay(): moment.Moment { return this._reportDay;} private _reportDay: moment.Moment;
    public set priceRelation(v: priceRelation) { this._priceRelation = v; } public get priceRelation(): priceRelation { return this._priceRelation;} private _priceRelation: priceRelation;
    
    showUpdateDollarPrices(){
        this.dataContext.showUpdateDollarPrices();
    }
    refreshUpdateCustomBenefits(){
        this.dataContext.refreshUpdateCustomBenefits();
    }
    async refresh(){
        this.dataContext.refresh();
    }

    exportToExcel(){
        this.dataContext.exportToExcel();
    }

    updatePrices(){
        this.dataContext.updatePrices();
    }

    showPriceSummaryHistory(){
        this.dataContext.showPriceSummaryHistory();
    }

    showSetPriceSummaryHistory(){
        this.dataContext.showSetPriceSummaryHistory();
    }
}
